/**
 * Service area type identifiers. Values mirror the trip-service
 * `specificityTier` enum so list rows can pass `data.specificityTier`
 * straight through to the cell renderer / tag without translation.
 *
 * Declared broadest-first, which is also the order the Type dropdown offers
 * them. The trip service resolves overlaps the other way — the most specific
 * tier wins: facility > subRegion > region > territory — so `territory` acts
 * as the bounded catch-all beneath the narrower areas. It still requires the
 * trip location to fall inside its boundary; it is not a wildcard.
 */
export const SERVICE_AREA_TYPE = Object.freeze({
  TERRITORY: 'territory',
  REGION: 'region',
  SUB_REGION: 'subRegion',
  FACILITY: 'facility',
});

/** Human-readable display labels for each SERVICE_AREA_TYPE value. */
export const SERVICE_AREA_TYPE_LABEL = Object.freeze({
  [SERVICE_AREA_TYPE.TERRITORY]: 'Territory',
  [SERVICE_AREA_TYPE.REGION]: 'Region',
  [SERVICE_AREA_TYPE.SUB_REGION]: 'Subregion',
  [SERVICE_AREA_TYPE.FACILITY]: 'Specific Location',
});

/**
 * Description for each SERVICE_AREA_TYPE value. Shown beside the option in the
 * Add Service Area modal's Coverage Level menu, and in the field itself once
 * the option is chosen — so every type needs one, and each has to stay short
 * enough to fit the field on one line.
 */
export const SERVICE_AREA_TYPE_DESCRIPTION = Object.freeze({
  [SERVICE_AREA_TYPE.TERRITORY]: 'Whole states. Your full coverage area.',
  [SERVICE_AREA_TYPE.REGION]: 'A metro area or group of counties.',
  [SERVICE_AREA_TYPE.SUB_REGION]: 'A single city or county.',
  [SERVICE_AREA_TYPE.FACILITY]:
    'One address, like a hospital or dialysis center.',
});
